export enum ECountryRegion {
  EUROPE = "Europe",
  NORTH_AMERICA = "North America",
  SOUTH_AMERICA = "South America",
  AFRICA = "Africa",
  ASIA = "Asia",
  AUSTRALIA_PACIFIC = "Australia Pacific",
  ANTARCTICA = "Antarctica",
  NONE = "None"
}
